import * as React from "react";

const RequestUpdate = props => {
  return <div>Böyle bir sayfa bulunmamaktadır.</div>;
};

const RbhRequestOrderUpdate = props => {
  return <RequestUpdate DataSource={props.DataSource} />;
};

export default RbhRequestOrderUpdate;
